import { createSlice } from "@reduxjs/toolkit";

import { PostsProps } from "./Posts";
import { RepostProps } from "./Repost";

const initialCreatePostAPI: PostsProps.CreatePostAPI = {};

const initialRepostAPI: RepostProps.API = { repostAPostAPIStatus: "idle" };

const initialState: PostsProps.State = {
  ...initialCreatePostAPI,
  ...initialRepostAPI,
  post_id: "",
  createPostOpen: false,
  uploadedImages: [],
  uploadedFiles: [],
  NewsFeed: {},
};

const slice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    setCreatePostDraftResponse: (
      state,
      action: PostsProps.setCreatePostDraftResponse
    ) => {
      state.post_id = action.payload.id;
    },
    setCreatePostOpen: (state, action: PostsProps.setCreatePostOpen) => {
      state.createPostOpen = action.payload;
    },

    setUploadsImageForAPostResponse: (
      state,
      action: PostsProps.setUploadsImageForAPostResponse
    ) => {
      state.uploadedImages = action.payload;
    },
    setUploadedFile: (state, action: PostsProps.setUploadedFile) => {
      const findFileIndex = state.uploadedFiles.findIndex(
        (file) => file.id === action.payload.fileId
      );
      if (findFileIndex === -1) {
        state.uploadedFiles = [...state.uploadedFiles, action.payload.image];
      } else {
        const newUploadedFiles = [...state.uploadedFiles];
        newUploadedFiles[findFileIndex] = action.payload.image;
        state.uploadedFiles = newUploadedFiles;
      }
    },
    setDeleteUploadedFile: (
      state,
      action: PostsProps.setDeleteUploadedFile
    ) => {
      state.uploadedFiles = state.uploadedFiles.filter(
        (file) => file.id !== action.payload
      );
    },
    setDeleteAllUploadedFile: (state) => {
      state.uploadedFiles = [];
    },

    resetCreatePostData: (state) => {
      state.post_id = "";
      state.uploadedImages = [];
      state.uploadedFiles = [];
      state.createPostOpen = false;
    },

    //#region Repost
    setRepostAPostAPIStatus: (
      state,
      action: RepostProps.setRepostAPostAPIStatus
    ) => {
      state.repostAPostAPIStatus = action.payload;
    },
    //#endregion
    reset: () => initialState,
  },
});

export const postsActions = slice.actions;
export const postsReducer = slice.reducer;
